import { starNews } from "@/mocks/homeNews";
import { SectionHead, Tag } from "./bits";

export default function StarSection() {
  return (
    <section id="star" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <SectionHead
          eyebrow="明星网红"
          title="明星网红的另一面，都在这里"
          desc="台前光鲜，幕后拉扯。镜头没拍到的，是我们帮你逐条梳理的重点。"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {starNews.map((s, i) => (
            <a
              key={s.id}
              href="#rebang"
              className="group flex items-stretch gap-0 overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 hover:bg-background-100 cursor-pointer"
            >
              <div className="relative w-32 md:w-44 shrink-0 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  title={`${s.title} | 每日黑料大曝光`}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0 p-4 flex flex-col">
                <div className="flex items-center justify-between gap-2 mb-2">
                  <Tag label={s.tag} tone={s.tagTone || "secondary"} />
                  <span className="text-xs text-foreground-600 whitespace-nowrap">{s.time}</span>
                </div>
                <h3 className="text-sm md:text-[15px] font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                  <span className="mr-1 font-heading text-primary-500">#{i + 1}</span>
                  {s.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2 hidden sm:block">
                  {s.summary}
                </p>
                <div className="mt-auto pt-3 flex items-center gap-2 text-xs text-foreground-600">
                  <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-primary-500" />
                  <span className="whitespace-nowrap">{s.reads}阅读</span>
                  <span className="ml-auto inline-flex items-center gap-1 font-medium text-primary-600 whitespace-nowrap">
                    讨论中 <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}